import React from "react";
import type { Message } from "../types";
import { ChatMessage } from "./ChatMessage";

interface ChatMessagesListProps {
  messages: Message[];
  userName: string;
}

export const ChatMessagesList: React.FC<ChatMessagesListProps> = ({
  messages,
  userName,
}) => {
  const messagesEndRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div className="chat-messages">
      {messages.map((message) => (
        <ChatMessage key={message.id} message={message} userName={userName} />
      ))}
      <div ref={messagesEndRef} />
    </div>
  );
};
